import React, { useEffect, useState } from 'react';

import NCSLogoIcon from '../../assets/ncs-logo-icon.svg';
import './styles.css';

const FloatingButtons = ({ data, changePage }) => {
    const [buttons, setButtons] = useState([]);

    useEffect(() => {
        if (data) {
            const buttonsInfo = data.map((page, index) => ({
                id: index,
                icon: page.icon,
                alt: page.island,
            }));

            setButtons(buttonsInfo);
        }
    }, [data, setButtons]);

    if (!data) return <></>;

    return (
        <nav id='ncs-floating-buttons'>
            {buttons.map((button, index) => {
                const maskUrl = index ? button.icon + '?not-from-cache' : NCSLogoIcon;

                return (
                    <button
                        id={`floating-button-${button.id}`}
                        key={button.id}
                        title={button.alt}
                        onClick={() => changePage(button.id)}
                    >
                        {button.icon && (
                            <div
                                style={{
                                    maskImage: `url(${maskUrl})`,
                                    WebkitMaskImage: `url(${maskUrl})`,
                                }}
                            />
                        )}
                        {button.icon && !button.id && <span>Início</span>}
                    </button>
                );
            })}
        </nav>
    );
};

export default FloatingButtons;
